module.exports = __webpack_public_path__ + "img/zuijia_15.78a7fd6e.png";